import * as React from "react"
import { useTranslation } from "react-i18next"
import Element from "@bappweb/element"
import Page from "@components/globalmodules/page"

const GetStarted = () => {
  const { t } = useTranslation()

  return (
    <Page>
      <Element type="h1">{t("Get Started")}</Element>
    </Page>
  )
}

export default GetStarted
